import { ConicGlow } from 'v2/Picture/ConicGlow'
import './Spinner.scss'
import { ConicGlowButton } from 'v2/Picture/ConicGlowButton'

export const Spinner = () => {
  return <span className="loader"></span>
}
